import React from 'react';
import Container from 'Nori/Container';
import Button from 'Nori/Button';
import styles from 'Custom/Finder/FinderSimple.module.scss';

const FinderSimple = ({
  title = '',
  className = '',
  designModuleNo = '00',
  buttonLabel = '',
  buttonHref = '/',
  children,
  ...props
}) => {
  return (
    <div
      className={`${styles.finderSimple} ${className}`}
      data-design-visible="visible_vd"
      data-design-type="module"
      data-design-nori_id="Inline Content"
      data-design-module_name={title}
      data-design-module_no={designModuleNo}
      data-qa-tag="finder-simple"
      {...props}
    >
      {/* <Container
        className={styles.finderContainer}
        data-qa-tag="finder-container"
      > */}
      <div className={styles.finderContainer}>
        <div className={styles.finderContent} data-qa-tag="finder-content">
          <h3 className={styles.finderTitle} data-qa-tag="finder-title">
            {title}
          </h3>
          <div className={styles.finderCopy} data-qa-tag="finder-copy">
            {children}
          </div>
        </div>
        {buttonLabel && (
          <Button
            type="primaryLight"
            size="small"
            href={buttonHref}
            data-design-type="clickAction"
            data-design-category="button_vd"
            data-design-action="Button"
            data-design-label={buttonLabel}
            data-design-nori_id="Inline Content"
            data-design-module_name={title}
            data-design-module_no={designModuleNo}
            data-qa-tag="finder-button"
            className={styles.finderButton}
          >
            {buttonLabel}
          </Button>
        )}
        </div>
      {/* </Container> */}
    </div>
  );
};

export default FinderSimple;
